module.exports = __webpack_public_path__ + "img/right-sign.3f3c19da.svg";